import { useMutation } from '@tanstack/react-query';

import { useRequest } from '../common';

interface QueryOptions {
  queryOptions: {
    onSuccess: () => void;
    onError: ({ message }: { message: string }) => void;
  };
}
type PreferredDistributor = {
  enableDefaultQtyBreakPricing: boolean | null;
  defaultPurchasedComponentQuantity: number | null;
  distributorId: number;
  isEnabled: boolean | null;
};

export const useUpdatePreferredDistributor = ({
  queryOptions,
}: QueryOptions) => {
  const request = useRequest({});

  return useMutation({
    mutationFn: (distributorData: PreferredDistributor) =>
      request(`/products/default_preferred_distributor/`, {
        init: {
          method: 'PATCH',
          body: distributorData,
        },
      }),
    ...queryOptions,
  });
};
